import { render, staticRenderFns } from "./Dongwu.vue?vue&type=template&id=b860e05e&scoped=true"
import script from "./Dongwu.vue?vue&type=script&lang=js"
export * from "./Dongwu.vue?vue&type=script&lang=js"
import style0 from "./Dongwu.vue?vue&type=style&index=0&id=b860e05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b860e05e",
  null
  
)

export default component.exports